import { useContext, useState } from "react";
import * as Scrivito from "scrivito";
import InPlaceEditingPlaceholder from "^/Components/InPlaceEditingPlaceholder";
import CookiesDeclinedBanner from "^/Components/PlaceholderWithCookieConsent";
import { CookieConsentContext } from "^/Components/CookieConsentContext";

function PlaceholderOrVimeoComponent({ title, vimeoVideoId, teaser }) {
  const { optionAllowed, setOptions } = useContext(CookieConsentContext);

  const [updated, setUpdated] = useState(0);

  let iframe = (
    <iframe
      title={title}
      src={`https://player.vimeo.com/video/${vimeoVideoId}`}
      allowFullScreen
    />
  );

  if (!vimeoVideoId) {
    iframe = (
      <InPlaceEditingPlaceholder>
        Provide a proper Vimeo video URL in the widget properties.
      </InPlaceEditingPlaceholder>
    );
  }

  if (!optionAllowed("vimeo")) {
    const currPage = Scrivito.currentPage();
    const lang = currPage.language();
    iframe = (
      <CookiesDeclinedBanner
        icon="lab la-vimeo"
        onAccept={() => {
          setOptions("vimeo", true);
          setUpdated(updated + 1);
        }}
        teaser={teaser}
        lang={lang}
        serviceType="video"
      />
    );
  }

  return <figure className="vimeo-video-container">{iframe}</figure>;
}

export default Scrivito.connect(PlaceholderOrVimeoComponent);
